<template>
  <form @submit.prevent="handleSubmit">
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <!-- First Name -->
      <div class="form-group">
        <label for="first_name" class="form-label">First Name</label>
        <input
          id="first_name"
          v-model="form.first_name"
          type="text"
          class="form-input"
          :disabled="loading"
          required>
      </div>

      <!-- Last Name -->
      <div class="form-group">
        <label for="last_name" class="form-label">Last Name</label>
        <input
          id="last_name"
          v-model="form.last_name"
          type="text"
          class="form-input"
          :disabled="loading"
          required>
      </div>

      <!-- Email -->
      <div class="form-group sm:col-span-2">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          v-model="form.email"
          type="email"
          class="form-input"
          :disabled="loading"
          required>
      </div>

      <!-- Phone -->
      <div class="form-group sm:col-span-2">
        <label for="phone" class="form-label">
          Phone Number
          <span class="form-label-optional">(optional)</span>
        </label>
        <input
          id="phone"
          v-model="form.phone"
          type="tel"
          class="form-input"
          :disabled="loading">
      </div>
    </div>

    <!-- Submit Button -->
    <div class="form-actions">
      <button
        type="submit"
        :disabled="saving || !hasChanges"
        class="btn btn-primary">
        <span v-if="saving" class="flex items-center gap-2">
          <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Saving...
        </span>
        <span v-else>Save Changes</span>
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import { isEqual } from 'lodash'

// Props
const props = defineProps({
  profile: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['update'])

// State
const saving = ref(false)
const originalForm = ref({})
const form = reactive({
  first_name: '',
  last_name: '',
  email: '',
  phone: ''
})

// Computed
const hasChanges = computed(() => !isEqual(form, originalForm.value))

// Methods
const populateForm = () => {
  Object.keys(form).forEach((key) => {
    form[key] = props.profile[key] || ''
  })
  originalForm.value = { ...form }
}

const handleSubmit = async() => {
  if (!hasChanges.value || saving.value) return

  saving.value = true

  try {
    await emit('update', { profile: { ...form } })
    originalForm.value = { ...form }
  } catch (error) {
    console.error('Failed to save profile:', error)
  } finally {
    saving.value = false
  }
}

// Watchers
watch(() => props.profile, (newProfile) => {
  if (newProfile && Object.keys(newProfile).length > 0) {
    populateForm()
  }
}, { immediate: true, deep: true })
</script>
